export default "__VITE_ASSET__C6N$IlqJ__"